import React from 'react';
import OneGroupByRoomTours from './OneGroupByRoomTours';

const GroupedByRoomTours = ({
  row,
  hideoperator = false,
  geoclient,
  row_fix,
  onAction,
  setOpenModal,
  setTourToShare,
  roomList,
  groupedTours,
}) => {

  return roomList.map((room) => (
    <OneGroupByRoomTours
      row={row}
      room={room}
      key={room}
      hideoperator={hideoperator}
      row_fix={row_fix}
      geoclient={geoclient}
      onAction={onAction}
      setOpenModal={setOpenModal}
      setTourToShare={setTourToShare}
      groupedTours={groupedTours}
    />
  ));
};

export default GroupedByRoomTours;
